'use client';

import { c as _c } from "react/compiler-runtime";
import { usePaginationState } from '@/components/Pagination/PaginationContext';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import { cn } from '@/lib/cn';
interface IconButtonProps {
  disabled: boolean;
  icon: string;
  label: string;
  onClick: () => void;
}
function IconButton(t0) {
  const $ = _c(11);
  const {
    disabled,
    icon,
    label,
    onClick
  } = t0;
  const t1 = !disabled;
  let t2;
  if ($[0] !== disabled || $[1] !== t1) {
    t2 = cn("btn rounded-full shadow-[0_4px_10px_0_rgba(0,0,0,0.1)] size-10 md:size-12 bg-white border-0", {
      "text-primary": t1,
      "text-neutral": disabled
    });
    $[0] = disabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== icon) {
    t3 = <PhosphorIcon className="text-[20px] md:text-[24px]" name={icon} />;
    $[3] = icon;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== disabled || $[6] !== label || $[7] !== onClick || $[8] !== t2 || $[9] !== t3) {
    t4 = <button className={t2} disabled={disabled} aria-label={label} onClick={onClick}>{t3}</button>;
    $[5] = disabled;
    $[6] = label;
    $[7] = onClick;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export interface PaginationProps {
  className?: string;
  itemCount: number;
  itemsPerPage: number;
}
export function Pagination(t0) {
  const $ = _c(25);
  const {
    className,
    itemCount,
    itemsPerPage
  } = t0;
  const {
    page,
    setPage
  } = usePaginationState();
  if (itemCount === 0 || itemsPerPage < 1) {
    return null;
  }
  const maxPage = Math.ceil(itemCount / itemsPerPage);
  const currentPage = page > maxPage ? maxPage : page;
  let t1;
  if ($[0] !== maxPage) {
    t1 = Array.from({
      length: maxPage
    }, _temp);
    $[0] = maxPage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pages = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("flex flex-row flex-wrap items-center justify-center gap-4", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = currentPage <= 1;
  let t4;
  if ($[4] !== currentPage || $[5] !== setPage) {
    t4 = () => setPage(currentPage - 1);
    $[4] = currentPage;
    $[5] = setPage;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <IconButton data-testid="pagination-prev" disabled={t3} icon="caret-left" label="Prev page" onClick={t4} />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== currentPage || $[11] !== pages || $[12] !== setPage) {
    t6 = pages.map(p => <button className={cn("btn size-11 rounded-lg border-0", {
      "btn-primary": p === currentPage,
      "bg-white font-normal": p !== currentPage
    })} data-testid={`pagination-${p}`} key={`page-${p}`} aria-label={`Go to ${p} page`} onClick={() => setPage(p)}>{p}</button>);
    $[10] = currentPage;
    $[11] = pages;
    $[12] = setPage;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = currentPage >= maxPage;
  let t8;
  if ($[14] !== currentPage || $[15] !== setPage) {
    t8 = () => setPage(currentPage + 1);
    $[14] = currentPage;
    $[15] = setPage;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <IconButton data-testid="pagination-next" disabled={t7} icon="caret-right" label="Next page" onClick={t8} />;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t5 || $[22] !== t6 || $[23] !== t9) {
    t10 = <div className={t2}>{t5}{t6}{t9}</div>;
    $[20] = t2;
    $[21] = t5;
    $[22] = t6;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
function _temp(_, i) {
  return i + 1;
}